// The material the editor works on: the active material tab's, the
// material SELECTED in the library (the library detail edits a material in
// place, library layout 2026-10-01), or the Studio's front open document
// (the desk edits it where it lies). One derivation, so the editor host's
// load fan-out, the quality dock, the export flow and a compose turn all
// follow the same material. Pure and total.

import type {
    ActiveTab,
    MaterialRef,
    ResourceId,
    ResourceRef,
} from "../../components/Navigation/types.js";

export const editedMaterialRef = (
    active: ActiveTab,
    refFor: (id: ResourceId) => ResourceRef | undefined,
    studioDocument?: ResourceId,
): MaterialRef | null => {
    const id =
        active.type === "resource"
            ? active.id
            : active.type === "search"
              ? active.selectedId
              : active.type === "studio"
                ? studioDocument
                : undefined;
    const ref = id === undefined ? undefined : refFor(id);
    return ref?.type === "material" ? ref : null;
};
